module.exports = __webpack_public_path__ + "static/media/jedi.93351071.svg";